import React from 'react';
export const SocialProofSection = () => {
  return <section className="w-full py-20 bg-gray-50" data-id="element-370">
      <div className="max-w-6xl mx-auto px-4" data-id="element-371">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-16" data-id="element-372">
          ONE TEŻ ODZYSKAŁY SWOJE MAŁŻEŃSTWA
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-373">
          <div className="bg-white p-6 rounded-lg shadow-md transform transition-all hover:scale-105" data-id="element-374">
            <div className="flex items-center mb-4" data-id="element-375">
              <div className="text-yellow-400 flex" data-id="element-376">★★★★★</div>
            </div>
            <p className="text-gray-700 mb-4" data-id="element-377">
              "Po 14 latach małżeństwa myślałam, że już nic się nie zmieni.
              Byłam jak duch we własnym domu. Dzięki tej metodzie mąż znów mnie
              widzi. Wczoraj przyniósł mi kwiaty bez okazji i przytulił mnie
              przed snem!"
            </p>
            <div className="flex items-center" data-id="element-378">
              <div className="mr-4" data-id="element-379">
                <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center text-red-600 font-bold" data-id="element-380">
                  M
                </div>
              </div>
              <div data-id="element-381">
                <p className="font-bold" data-id="element-382">Magda, 39 lat</p>
                <p className="text-sm text-gray-500" data-id="element-383">Warszawa</p>
              </div>
            </div>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md transform transition-all hover:scale-105" data-id="element-384">
            <div className="flex items-center mb-4" data-id="element-385">
              <div className="text-yellow-400 flex" data-id="element-386">★★★★★</div>
            </div>
            <p className="text-gray-700 mb-4" data-id="element-387">
              "Po 22 latach znów czujemy się jak para. Mąż zaczął mnie zauważać,
              doceniać. Wczoraj powiedział, że jestem najpiękniejszą kobietą w
              jego życiu. Płakałam ze szczęścia. Po 22 latach małżeństwa znów
              się całujemy!"
            </p>
            <div className="flex items-center" data-id="element-388">
              <div className="mr-4" data-id="element-389">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 font-bold" data-id="element-390">
                  K
                </div>
              </div>
              <div data-id="element-391">
                <p className="font-bold" data-id="element-392">Kasia, 47 lat</p>
                <p className="text-sm text-gray-500" data-id="element-393">Gdańsk</p>
              </div>
            </div>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md transform transition-all hover:scale-105" data-id="element-394">
            <div className="flex items-center mb-4" data-id="element-395">
              <div className="text-yellow-400 flex" data-id="element-396">★★★★★</div>
            </div>
            <p className="text-gray-700 mb-4" data-id="element-397">
              "Już nie jestem duchem w domu. Mąż znów mnie przytula, rozmawiamy,
              śmiejemy się. Nie pamiętam, kiedy ostatnio czułam się tak kochana
              i doceniana. Przestałam być duchem - jestem znów ŻONĄ!"
            </p>
            <div className="flex items-center" data-id="element-398">
              <div className="mr-4" data-id="element-399">
                <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center text-green-600 font-bold" data-id="element-400">
                  B
                </div>
              </div>
              <div data-id="element-401">
                <p className="font-bold" data-id="element-402">Beata, 41 lat</p>
                <p className="text-sm text-gray-500" data-id="element-403">Wrocław</p>
              </div>
            </div>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md transform transition-all hover:scale-105" data-id="element-404">
            <div className="flex items-center mb-4" data-id="element-405">
              <div className="text-yellow-400 flex" data-id="element-406">★★★★★</div>
            </div>
            <p className="text-gray-700 mb-4" data-id="element-407">
              "Po 18 latach małżeństwa byliśmy jak współlokatorzy. Dzięki tej
              metodzie odzyskałam nie tylko męża, ale i siebie. Znów czuję się
              kobietą, a nie tylko matką i gospodynią. Pierwszy raz od 10 lat
              powiedział: KOCHAM CIĘ!"
            </p>
            <div className="flex items-center" data-id="element-408">
              <div className="mr-4" data-id="element-409">
                <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center text-purple-600 font-bold" data-id="element-410">
                  A
                </div>
              </div>
              <div data-id="element-411">
                <p className="font-bold" data-id="element-412">Anna, 45 lat</p>
                <p className="text-sm text-gray-500" data-id="element-413">Poznań</p>
              </div>
            </div>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md transform transition-all hover:scale-105" data-id="element-414">
            <div className="flex items-center mb-4" data-id="element-415">
              <div className="text-yellow-400 flex" data-id="element-416">★★★★★</div>
            </div>
            <p className="text-gray-700 mb-4" data-id="element-417">
              "Myślałam, że moje małżeństwo to już tylko formalność. Teraz mąż
              znów na mnie patrzy jak kiedyś. Wczoraj powiedział, że jestem
              miłością jego życia. Znów czuję motyle w brzuchu po 15 latach!"
            </p>
            <div className="flex items-center" data-id="element-418">
              <div className="mr-4" data-id="element-419">
                <div className="w-10 h-10 bg-yellow-100 rounded-full flex items-center justify-center text-yellow-600 font-bold" data-id="element-420">
                  J
                </div>
              </div>
              <div data-id="element-421">
                <p className="font-bold" data-id="element-422">Joanna, 43 lata</p>
                <p className="text-sm text-gray-500" data-id="element-423">Kraków</p>
              </div>
            </div>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md transform transition-all hover:scale-105" data-id="element-424">
            <div className="flex items-center mb-4" data-id="element-425">
              <div className="text-yellow-400 flex" data-id="element-426">★★★★★</div>
            </div>
            <p className="text-gray-700 mb-4" data-id="element-427">
              "Po 3 miesiącach stosowania tej metody mój mąż sam zaproponował
              terapię małżeńską. Teraz rozmawiamy, słuchamy się nawzajem. Znów
              jesteśmy parą. Wczoraj pierwszy raz od lat trzymaliśmy się za ręce
              na spacerze."
            </p>
            <div className="flex items-center" data-id="element-428">
              <div className="mr-4" data-id="element-429">
                <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center text-red-600 font-bold" data-id="element-430">
                  E
                </div>
              </div>
              <div data-id="element-431">
                <p className="font-bold" data-id="element-432">Ewa, 44 lata</p>
                <p className="text-sm text-gray-500" data-id="element-433">Łódź</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};